// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.container {
    text-align: center;

    .inner-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            max-width: 400px;
            width: 100%; 
        }

        .title {
            font-size: 2rem;
            font-weight: bold;
            color: #000;
            margin-bottom: 1rem;
        }

        .description {
            font-size: 1rem;
            color: #000;
        }
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/views/restricted-words-management/restricted-words-management.component.css"],"names":[],"mappings":";;AAEA;IACI,kBAAkB;;IAElB;QACI,aAAa;QACb,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;;QAEnB;YACI,gBAAgB;YAChB,WAAW;QACf;;QAEA;YACI,eAAe;YACf,iBAAiB;YACjB,WAAW;YACX,mBAAmB;QACvB;;QAEA;YACI,eAAe;YACf,WAAW;QACf;IACJ;AACJ","sourcesContent":["\r\n\r\n.container {\r\n    text-align: center;\r\n\r\n    .inner-content {\r\n        display: flex;\r\n        flex-direction: column;\r\n        justify-content: center;\r\n        align-items: center;\r\n\r\n        img {\r\n            max-width: 400px;\r\n            width: 100%; \r\n        }\r\n\r\n        .title {\r\n            font-size: 2rem;\r\n            font-weight: bold;\r\n            color: #000;\r\n            margin-bottom: 1rem;\r\n        }\r\n\r\n        .description {\r\n            font-size: 1rem;\r\n            color: #000;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
